import React from 'react';
import className from 'classnames';
import moment from 'moment';
import {get} from 'lodash';

import {
  canBan,
} from '../lib/policies';

import {useCheckIds} from '../hooks';

import OverflowH from './OverflowH';
import LiftBanModal from './LiftBanModal';
import TableHeader from './TableHeader';

const PermanentBannedUsersList = ({
  users = [],
  total = 0,
}) => {
  const {
    checkIds,
    renderCheckBox, renderCheckBoxForCheckAll,
    renderOpenAllButton,
  } = useCheckIds({
    data: users,
    openUrl: 'banned_users',
  })

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Permanent banned users list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} users</p>
        </div>

        {renderOpenAllButton()}
      </div>

      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}
      </div>

      <div className='Table Table--permanent-banned-users-list'>
        {(() => {
          const columnHeaders = [
            {
              label: '',
            },
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'Nickname',
            },
            {
              label: 'Lastest Note',
            },
            {
              label: 'IP Address',
            },
            {
              label: 'Registered IP Address',
            },
            {
              label: 'UUID',
            },
            {
              label: 'Banned by',
            },
            {
              label: 'Banned at',
              sortKey: 'created_at',
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {users.map((user) => (
          <div
            className={className('Table__row', {
              'Table__row--active': checkIds.includes(user.id),
            })}
            key={`${user.id}_${user.createdAt}`}
            data-x={user}
          >
            <div className='Table__col'>
              {renderCheckBox(user)}
            </div>

            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/${gon.currentProvider}/banned_users/${user.id}`}
              >
                {user.id}
              </a>
            </div>

            <div className='Table__col'>{user.nickname}</div>
            <div className='Table__col'>
              <OverflowH
                text={user.lastNote}
              />
            </div>

            <div className='Table__col'>{get(user, 'ipAddress')}</div>

            <div className='Table__col'>{get(user, 'registeredIpAddress')}</div>

            <div className='Table__col'>{user.uuid}</div>

            <div className='Table__col'>
              {user.adminEmail}
            </div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: user.createdAt !== null ?
                    moment(user.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              <div className='Table__controls'>
                {canBan('User') &&
                  <LiftBanModal
                    klassName='Table__controls__a Table__controls__a--lock-green'
                    id={user.id}
                    reload
                    banType='permanent'
                  />
                }
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default PermanentBannedUsersList;
